import {Component, Vue} from 'vue-property-decorator'

type Fn = () => void;

// Миксин позволяет задавать функцию для периодического выполнения в компоненте и функцию, которая вызывается при
// активации компонента или вкладки в браузере
// Миксин требует инициализации через вызов initRefresh
@Component
class PeriodicRefreshMixin extends Vue {
    timerId: number | null = null;
    refreshTimeout: number | null = null; // периодичность запуска функции обновления данных в миллисекундах
    activateLimitTimeout: number | null = null; // ограничение на частоту запуска функции перезагрузки данных при переключении таба, в миллисекундах
    refreshFunction: Fn | null = null;
    activateFunction: Fn | null = null;

    lastActivated = 0;

    async activated() {
        if (this.activateLimitTimeout !== null && Date.now() > this.lastActivated + this.activateLimitTimeout) {
            this.lastActivated = Date.now();
            this.activateFunction && await this.activateFunction();
        }
        this.enableAutoUpdate();
    }

    deactivated() {
        this.disableAutoUpdate();
    }

    beforeDestroy() {
        this.disableAutoUpdate();
        document.removeEventListener("visibilitychange", this);
    }

    /* Инициализация миксина
    * @param refreshFn Function to periodic call
    * @param refreshTimeout How often to call refreshFn, in milliseconds
    * @param activateFn Function to call when browser tab is selected or component activated
    * @param activateLimitTimeout Parameters to limit frequency activateFn calls, in milliseconds
    */
    initRefresh(refreshFn: Fn | null, refreshTimeout: number | null, activateFn: Fn | null = null, activateLimitTimeout: number | null = null) {
        this.setRefreshFn(refreshFn, refreshTimeout);

        this.activateFunction = activateFn;
        this.activateLimitTimeout = activateLimitTimeout;
        this.lastActivated = Date.now();

        document.addEventListener("visibilitychange", this);
    }

    // Смена периодически вызываемой функции
    setRefreshFn(refreshFn: Fn | null, refreshTimeout: number | null) {
        this.disableAutoUpdate();
        this.refreshFunction = refreshFn;
        this.refreshTimeout = refreshTimeout;
        this.enableAutoUpdate();
    }

    disableAutoUpdate() {
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
    }

    enableAutoUpdate() {
        if (this.refreshTimeout && this.refreshFunction && this.timerId === null) {

            this.timerId = window.setInterval(() => {
                if (!document.hidden) {
                    this.refreshFunction && this.refreshFunction();
                }
            }, this.refreshTimeout);
        }
    }

    async handleEvent(event: Event) {
        if (event.type === 'visibilitychange') {
            if (document.hidden) {
                this.disableAutoUpdate();
            } else {
                if (this.activateLimitTimeout !== null && this.activateFunction
                    && Date.now() > this.lastActivated + this.activateLimitTimeout) {
                    this.lastActivated = Date.now();
                    await this.activateFunction();
                }
                this.enableAutoUpdate();
            }
        }
    }
}

export default PeriodicRefreshMixin;
